import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import * as mockData from "../../tools/mockData";
import * as userActions from "../../redux/actions/userActions";
import * as recipeActions from "../../redux/actions/recipeActions";
import * as profileActions from "../../redux/actions/profileActions";
import Recipe from "./Recipe";
import Spinner from "../common/Spinner";

export function RecipePageContainer({
  recipes,
  actions,
  viewingUser,
  signedIn,
  favorites,
  ...props
}) {
  const [recipe, setRecipe] = useState({});

  useEffect(() => {
    if (recipes.length === 0) {
      actions.loadRecipeFromParams(props.match.params.slug).catch((error) => {
        if (error === "Invalid slug") {
          return props.history.push("/cookbook/404");
        }
        alert("failed loading recipes: " + error);
      });
    } else {
      setRecipe(
        recipes.filter((recipe) => recipe._id === props.match.params.slug)[0]
      );
    }
  }, [recipes.length]);

  if (recipes.length === 0) {
    return <Spinner />;
  } else if (recipe.hasOwnProperty("_id")) {
    return (
      <Recipe
        recipe={recipe}
        viewingUser={viewingUser}
        userSlug={props.match.params.username || ""}
        favorites={favorites}
        signedIn={signedIn}
      />
    );
  } else {
    return <p>app is not available.</p>;
  }
}

RecipePageContainer.propTypes = {
  recipe: PropTypes.object.isRequired,
  recipes: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
  viewingUser: PropTypes.object.isRequired,
  favorites: PropTypes.array,
  history: PropTypes.object.isRequired,
  signedIn: PropTypes.bool,
  match: PropTypes.object,
};

export function getRecipeBySlug(dataset, slug) {
  return dataset.find((recipe) => recipe.slug === slug) || null;
}

function mapStateToProps(state, ownProps) {
  const slug = ownProps.match.params.slug;
  const recipe =
    slug && state.recipes.recipes.length > 0
      ? getRecipeBySlug(state.recipes.recipes, slug)
      : mockData.newRecipe;
  return {
    recipes: state.recipes.recipes,
    viewingUser: state.viewingUser || {},
    signedIn: state.user.signedIn,
    recipe: recipe || {},
    favorites: state.profile.favorites,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      loadRecipeFromParams: bindActionCreators(
        recipeActions.loadRecipeById,
        dispatch
      ),
      getUserData: userActions.collectLocalStorageValues,
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecipePageContainer);
